import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

export interface InventoryItem {
  id: string;
  name: string;
  description: string;
  category: string;
  condition: string;
  purchasePrice: number;
  estimatedValue: number;
  currentValue: number;
  quantity: number;
  images: string[];
  createdAt: string;
  updatedAt: string;
}

export interface InventoryState {
  items: InventoryItem[];
  loading: 'idle' | 'pending' | 'succeeded' | 'failed';
  error: string | null;
  selectedItem: InventoryItem | null;
}

const initialState: InventoryState = {
  items: [],
  loading: 'idle',
  error: null,
  selectedItem: null,
};

export const fetchInventory = createAsyncThunk(
  'inventory/fetchInventory',
  async () => {
    // TODO: Replace with actual API call
    return Promise.resolve([]);
  }
);

const inventorySlice = createSlice({
  name: 'inventory',
  initialState,
  reducers: {
    selectItem(state, action: PayloadAction<string>) {
      state.selectedItem = state.items.find(item => item.id === action.payload) || null;
    },
    clearSelectedItem(state) {
      state.selectedItem = null;
    },
    updateItem(state, action: PayloadAction<InventoryItem>) {
      const index = state.items.findIndex(item => item.id === action.payload.id);
      if (index !== -1) {
        state.items[index] = action.payload;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInventory.pending, (state) => {
        state.loading = 'pending';
        state.error = null;
      })
      .addCase(fetchInventory.fulfilled, (state, action) => {
        state.loading = 'succeeded';
        state.items = action.payload;
      })
      .addCase(fetchInventory.rejected, (state, action) => {
        state.loading = 'failed';
        state.error = action.error.message || 'Failed to fetch inventory';
      });
  },
});

export const { selectItem, clearSelectedItem, updateItem } = inventorySlice.actions;
export default inventorySlice.reducer;
